import { computed } from 'mobx';
import { Fix } from '../../../../../utils/string';

/**
 * 모델
 * @window w_tb_pb401
 * @category 출장보고서
 */

export class TripModel {
  /**
   * 회사코드
   *
   * **data type** varchar(8)
   */
  readonly custcd: string;

  /**
   * 사업장코드
   *
   * **data type** varchar(2)
   */
  readonly spjangcd: string;

  /**
   *
   *
   * **data type** varchar(0)
   */
  readonly datetime: string;

  /**
   *
   *
   * **data type** varchar(8)
   */
  readonly outdate: string;

  /**
   *
   *
   * **data type** varchar(4)
   */
  readonly outnum: string;

  /**
   *
   *
   * **data type** varchar(1)
   */
  readonly kmflag: string;

  /**
   *
   *
   * **data type** varchar(4)
   */
  readonly gubun: string;

  /**
   *
   *
   * **data type** varchar(10)
   */
  readonly perid: string;

  /**
   *
   *
   * **data type** varchar(30)
   */
  readonly pernm: string;

  /**
   *
   *
   * **data type** varchar(40)
   */
  readonly divinm: string;

  /**
   *
   *
   * **data type** varchar(20)
   */
  readonly rspnm: string;

  /**
   *
   *
   * **data type** varchar(255)
   */
  readonly title: string;

  /**
   *
   *
   * **data type** varchar(13)
   */
  readonly actcd: string;

  /**
   *
   *
   * **data type** varchar(255)
   */
  readonly actnm: string;

  /**
   *
   *
   * **data type** varchar(13)
   */
  readonly cltcd: string;

  /**
   *
   *
   * **data type** varchar(255)
   */
  readonly cltnm: string;

  /**
   *
   *
   * **data type** varchar(1)
   */
  readonly weekflag: string;

  /**
   *
   *
   * **data type** varchar(0)
   */
  readonly datetime2: string;

  /**
   *
   *
   * **data type** varchar(8)
   */
  readonly stdate: string;

  /**
   *
   *
   * **data type** varchar(0)
   */
  readonly datetime3: string;

  /**
   *
   *
   * **data type** varchar(8)
   */
  readonly enddate: string;

  /**
   *
   *
   * **data type** varchar(255)
   */
  readonly outpernm: string;

  /**
   *
   *
   * **data type** varchar(32764)
   */
  readonly remark: string;

  /**
   *
   *
   * **data type** varchar(32764)
   */
  readonly result: string;

  /**
   *
   *
   * **data type** varchar(8)
   */
  readonly appdate: string;

  /**
   *
   *
   * **data type** varchar(6)
   */
  readonly apptime: string;

  /**
   *
   *
   * **data type** varchar(3)
   */
  readonly appgubun: string;

  /**
   *
   *
   * **data type** varchar(20)
   */
  readonly appnum: string;

  /**
   *
   *
   * **data type** varchar(255)
   */
  readonly appremark: string;

  /**
   *
   *
   * **data type** varchar(10)
   */
  readonly appperid: string;

  /**
   *
   *
   * **data type** varchar(1)
   */
  readonly picflag: string;

  /**
   *
   *
   * **data type** varchar(0)
   */
  readonly attcnt: number;

  /**
   *
   *
   * **data type** varchar(32764)
   */
  readonly refer: string;

  /**
   *
   *
   * **data type** varchar(8)
   */
  readonly snddate: string;

  /**
   *
   *
   * **data type** varchar(1)
   */
  readonly sndflag: string;

  /**
   *
   *
   * **data type** varchar(1)
   */
  readonly r_color: string;

  /**
   *
   *
   * **data type** varchar(1)
   */
  readonly gs_color: string;

  /**
   *
   *
   * **data type** varchar(1)
   */
  readonly newrow: string;

  new: string;

  constructor(data: any = {}, isNew: boolean = false) {
    this.custcd = data.custcd || '';
    this.spjangcd = data.spjangcd || '';
    this.datetime = data.datetime || '';
    this.outdate = data.outdate || '';
    this.outnum = data.outnum || '';
    this.kmflag = data.kmflag || '0';
    this.gubun = data.gubun || '001';
    this.perid = data.perid || '';
    this.pernm = data.pernm || '';
    this.divinm = data.divinm || '';
    this.rspnm = data.rspnm || '';
    this.title = data.title || '';
    this.actcd = data.actcd || '';
    this.actnm = data.actnm || '';
    this.cltcd = data.cltcd || '';
    this.cltnm = data.cltnm || '';
    this.weekflag = data.weekflag || '0';
    this.datetime2 = data.datetime2 || '';
    this.stdate = data.stdate || '';
    this.datetime3 = data.datetime3 || '';
    this.enddate = data.enddate || '';
    this.outpernm = data.outpernm || '';
    this.remark = Fix.newline(data.remark) || '';
    this.result = Fix.newline(data.result) || '';
    this.appdate = data.appdate || '';
    this.apptime = data.apptime || '';
    this.appgubun = data.appgubun || '';
    this.appnum = data.appnum || '';
    this.appremark = Fix.newline(data.appremark) || '';
    this.appperid = data.appperid || '';
    this.picflag = data.picflag || '0';
    this.attcnt = data.attcnt || '0';
    this.refer = data.refer || '';
    this.snddate = data.snddate || '';
    this.sndflag = data.sndflag || '';
    this.r_color = data.r_color || '';
    this.gs_color = data.gs_color || '';
    this.newrow = data.newrow || '';

    this.new = isNew ? '1' : '0';
  }

  @computed
  get isNew() {
    return this.new === '1';
  }
}
